import React from "react";
import {
    BriefcaseBusiness,
    Tags,
    Truck,
    Sparkles,
    UtensilsCrossed,
    Wrench,
    MonitorSmartphone,
    Palette,
    Package,
    ShoppingBasket,
    Gift,
    Music4,
    PartyPopper,
    Boxes,
    Wheat,
    Sprout,
    Hammer,
    ShieldCheck,
    Droplets,
    PawPrint,
    Baby,
    GraduationCap,
    Dumbbell,
    Bike,
    Tent,
    BookOpen,
    Home,
    BedDouble,
    HeartPulse,
    Stethoscope,
    Scissors,
    Gem,
    Footprints,
    Watch,
    Wine,
    Beer,
    IceCreamBowl,
    Beef,
    Fish,
    Camera,
    Tv,
    Gamepad2,
    Smartphone,
    Laptop,
    Keyboard,
    Cpu,
    Car,
    CarFront,
    Disc3,
    BatteryCharging,
    Fuel,
    SunMedium,
    LampDesk,
    Shirt,
    ShoppingBag,
    LucideIcon,
    Printer,
} from "lucide-react";

export interface CategoryVisual {
    icon: LucideIcon;
    color: string;
}

const normalizeCategoryName = (value: string = "") =>
    value
        .trim()
        .toLowerCase()
        .replace(/&/g, "and")
        .replace(/\s+/g, " ")
        .replace(/glocery/g, "grocery");

const categoryVisualMap: Record<string, CategoryVisual> = {
    services: { icon: BriefcaseBusiness, color: "#3B82F6" },
    "marketplace deals": { icon: Tags, color: "#8B5CF6" },
    "logistics and delivery": { icon: Truck, color: "#06B6D4" },
    "cleaning services": { icon: Sparkles, color: "#14B8A6" },
    "restaurant supplies": { icon: UtensilsCrossed, color: "#F97316" },
    "repair services": { icon: Wrench, color: "#EF4444" },
    "digital products": { icon: MonitorSmartphone, color: "#6366F1" },
    "arts and crafts": { icon: Palette, color: "#EC4899" },
    wholesale: { icon: Boxes, color: "#0EA5E9" },
    "bulk food supplies": { icon: Package, color: "#F59E0B" },
    "gift cards": { icon: Gift, color: "#A855F7" },
    "musical instruments": { icon: Music4, color: "#8B5CF6" },
    "party supplies": { icon: PartyPopper, color: "#F43F5E" },
    software: { icon: Cpu, color: "#4F46E5" },
    accommodation: { icon: Home, color: "#0EA5E9" },
    "industrial equipment": { icon: Boxes, color: "#475569" },
    generators: { icon: LampDesk, color: "#F59E0B" },
    "events and tickets": { icon: PartyPopper, color: "#E11D48" },
    "hikes and tours": { icon: Tent, color: "#16A34A" },
    "car hire": { icon: CarFront, color: "#2563EB" },
    "travel and luggage": { icon: ShoppingBag, color: "#0891B2" },
    "solar and energy": { icon: SunMedium, color: "#EAB308" },
    "farm tools": { icon: Hammer, color: "#65A30D" },
    "building materials": { icon: Package, color: "#78716C" },
    construction: { icon: Hammer, color: "#DC2626" },
    "electrical supplies": { icon: BatteryCharging, color: "#F59E0B" },
    "safety equipment": { icon: ShieldCheck, color: "#DC2626" },
    "plumbing supplies": { icon: Droplets, color: "#0EA5E9" },
    "animal feed": { icon: PawPrint, color: "#65A30D" },
    irrigation: { icon: Droplets, color: "#0284C7" },
    "baby products": { icon: Baby, color: "#F472B6" },
    agriculture: { icon: Wheat, color: "#65A30D" },
    fertilizers: { icon: Sprout, color: "#84CC16" },
    "pet supplies": { icon: PawPrint, color: "#F97316" },
    seeds: { icon: Sprout, color: "#22C55E" },
    "toys and games": { icon: Gamepad2, color: "#EC4899" },
    "team sports": { icon: Dumbbell, color: "#2563EB" },
    cycling: { icon: Bike, color: "#16A34A" },
    "fitness equipment": { icon: Dumbbell, color: "#EA580C" },
    "sports and outdoors": { icon: Tent, color: "#0F766E" },
    "school supplies": { icon: GraduationCap, color: "#7C3AED" },
    "camping and hiking": { icon: Tent, color: "#15803D" },
    "printers and ink": { icon: Printer, color: "#4B5563" },
    "office supplies": { icon: BriefcaseBusiness, color: "#64748B" },
    "cleaning supplies": { icon: Sparkles, color: "#14B8A6" },
    "home decor": { icon: Home, color: "#F59E0B" },
    books: { icon: BookOpen, color: "#7C3AED" },
    "storage and organization": { icon: Boxes, color: "#0F766E" },
    bedding: { icon: BedDouble, color: "#A855F7" },
    "medical supplies": { icon: Stethoscope, color: "#DC2626" },
    "health supplements": { icon: HeartPulse, color: "#059669" },
    "kitchen appliances": { icon: UtensilsCrossed, color: "#EA580C" },
    "home and kitchen": { icon: Home, color: "#F97316" },
    "personal care": { icon: Sparkles, color: "#EC4899" },
    furniture: { icon: Home, color: "#A16207" },
    cookware: { icon: UtensilsCrossed, color: "#FB923C" },
    "bags and luggage": { icon: ShoppingBag, color: "#0284C7" },
    jewelry: { icon: Gem, color: "#D946EF" },
    shoes: { icon: Footprints, color: "#2563EB" },
    watches: { icon: Watch, color: "#475569" },
    "beauty and health": { icon: HeartPulse, color: "#EC4899" },
    skincare: { icon: Sparkles, color: "#F472B6" },
    makeup: { icon: Sparkles, color: "#DB2777" },
    "hair care": { icon: Scissors, color: "#A855F7" },
    "kids fashion": { icon: Shirt, color: "#F59E0B" },
    fashion: { icon: Shirt, color: "#7C3AED" },
    "mens clothing": { icon: Shirt, color: "#2563EB" },
    "womens clothing": { icon: Shirt, color: "#DB2777" },
    "tools and garage": { icon: Wrench, color: "#475569" },
    motorcycles: { icon: Bike, color: "#DC2626" },
    spirits: { icon: Wine, color: "#7C2D12" },
    mixers: { icon: Wine, color: "#0EA5E9" },
    "car parts": { icon: Car, color: "#475569" },
    tyres: { icon: Disc3, color: "#111827" },
    batteries: { icon: BatteryCharging, color: "#EAB308" },
    "engine oils and fluids": { icon: Fuel, color: "#F97316" },
    "car accessories": { icon: CarFront, color: "#3B82F6" },
    beer: { icon: Beer, color: "#F59E0B" },
    snacks: { icon: ShoppingBasket, color: "#F97316" },
    bakery: { icon: UtensilsCrossed, color: "#D97706" },
    "dairy and eggs": { icon: ShoppingBasket, color: "#EAB308" },
    seafood: { icon: Fish, color: "#0EA5E9" },
    wine: { icon: Wine, color: "#7C3AED" },
    beverages: { icon: Wine, color: "#06B6D4" },
    "frozen foods": { icon: IceCreamBowl, color: "#38BDF8" },
    "meat and poultry": { icon: Beef, color: "#DC2626" },
    liquor: { icon: Wine, color: "#9333EA" },
    cameras: { icon: Camera, color: "#334155" },
    grocery: { icon: ShoppingBasket, color: "#22C55E" },
    "fresh produce": { icon: ShoppingBasket, color: "#16A34A" },
    "smart home": { icon: Home, color: "#6366F1" },
    computers: { icon: MonitorSmartphone, color: "#2563EB" },
    "computer accessories": { icon: Keyboard, color: "#4F46E5" },
    laptops: { icon: Laptop, color: "#1D4ED8" },
    "phone accessories": { icon: Smartphone, color: "#0891B2" },
    "mobile phones": { icon: Smartphone, color: "#0284C7" },
    electronics: { icon: MonitorSmartphone, color: "#4F46E5" },
};

function PrinterFallbackIcon(props: any) {
    return <Keyboard {...props} />;
}

export const getCategoryVisual = (categoryName: string = ""): CategoryVisual => {
    const normalized = normalizeCategoryName(categoryName);

    return (
        categoryVisualMap[normalized] || {
            icon: Package,
            color: "#64748B",
        }
    );
};

export const normalizeCategoryLabel = (categoryName: string = "") => {
    const normalized = normalizeCategoryName(categoryName);

    if (normalized === "glocery") return "Grocery";
    if (normalized === "grocery") return "Grocery";

    return categoryName.trim();
};